import axios from 'axios';
import { API_BASE_URL } from '../../../config';

const BASE = `${API_BASE_URL}/payment-rail-settings`;

export class PaymentRailSettingsApi {
  static list = (params = {}) => axios.get(BASE, { params });

  static getForForms = () => axios.get(`${BASE}/for-forms`);

  static get = (id) => axios.get(`${BASE}/${id}`);

  static create = (data) => axios.post(BASE, data);

  static update = (id, data) => axios.put(`${BASE}/${id}`, data);

  static delete = (id) => axios.delete(`${BASE}/${id}`);
}
